const notempty = (element) => {
    return !!(element.value)
}

export default notempty